<div class="lead-page">
  <div class="lead-shell">
    <div class="lead-header">
      <div class="lead-title">
        <h2>Leads</h2>
        <p>Track enquiries, ownership, and next actions.</p>
      </div>
      <div class="lead-actions">
        <button class="lead-btn" (click)="openCreate()">Create Lead</button>
      </div>
    </div>

    <div class="lead-filters">
      <div class="lead-filter-field">
        <label>Search</label>
        <input [(ngModel)]="filters.search" placeholder="Customer / contact / phone" />
      </div>
      <div class="lead-filter-field">
        <label>Status</label>
        <select [(ngModel)]="filters.status">
          <option value="">All Status</option>
          <option *ngFor="let status of statuses" [value]="status[0]">{{ status[1] }}</option>
        </select>
      </div>
      <div class="lead-filter-field">
        <label>Source</label>
        <select [(ngModel)]="filters.source">
          <option value="">All Sources</option>
          <option *ngFor="let source of sources" [value]="source[0]">{{ source[1] }}</option>
        </select>
      </div>
      <div class="lead-filter-field">
        <label>Assigned To</label>
        <select [(ngModel)]="filters.assigned_to">
          <option value="">All Assignees</option>
          <option *ngFor="let assignee of assignees" [value]="assignee.id">
              {{ assigneeLabel(assignee) }}
          </option>
        </select>
      </div>
      <div class="lead-filter-field">
        <label>Date From</label>
        <p-datepicker
          [(ngModel)]="filters.date_from"
          dateFormat="dd/mm/yy"
          [showIcon]="true"
          inputId="lead-date-from"
          [showOnFocus]="true"
          [showButtonBar]="true"
          [readonlyInput]="true">
        </p-datepicker>
      </div>
      <div class="lead-filter-field">
        <label>Date To</label>
        <p-datepicker
          [(ngModel)]="filters.date_to"
          dateFormat="dd/mm/yy"
          [showIcon]="true"
          inputId="lead-date-to"
          [showOnFocus]="true"
          [showButtonBar]="true"
          [readonlyInput]="true">
        </p-datepicker>
      </div>
      <div class="lead-filter-field" *ngIf="canFilterOrganization">
        <label>Organization</label>
        <select [(ngModel)]="filters.organization">
          <option value="">All Organizations</option>
          <option *ngFor="let organization of organizations" [value]="organization.id">{{ organization.name }}</option>
        </select>
      </div>
    </div>

    <div class="inline-actions">
      <button class="lead-btn-secondary" (click)="applyFilters()">Apply Filters</button>
      <button class="lead-btn-muted filter-reset-btn" (click)="resetFilters()">Reset</button>
    </div>

    <div class="lead-loading" *ngIf="loading">Loading leads...</div>

    <div class="lead-table-wrap" *ngIf="!loading">
      <table class="lead-table">
        <thead>
          <tr>
            <th>Lead ID</th>
            <th>Customer Name</th>
            <th>Contact Person</th>
            <th>Phone Number</th>
            <th>Source</th>
            <th>Partner</th>
            <th>City</th>
            <th>Status</th>
            <th>Assigned To</th>
            <th>Next Follow-up</th>
            <th>Created Date</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="!leads.length">
            <td colspan="12" class="lead-empty">No leads found.</td>
          </tr>
          <tr *ngFor="let lead of leads">
            <td>{{ lead.lead_id }}</td>
            <td>{{ lead.customer_name }}</td>
            <td>{{ lead.contact_person || '-' }}</td>
            <td>{{ lead.phone_number }}</td>
            <td>{{ lead.source_label }}</td>
            <td>{{ lead.sales_installation_partner_name || '-' }}</td>
            <td>{{ lead.city || '-' }}</td>
            <td><span class="lead-status {{ lead.status }}">{{ lead.status_label }}</span></td>
            <td>{{ lead.assigned_to_name || 'Unassigned' }}</td>
            <td>{{ lead.next_follow_up_date || '-' }}</td>
            <td>{{ lead.created_at | date: 'dd/MM/yyyy' }}</td>
            <td class="table-actions-cell">
              <div class="table-actions">
                <button class="action-button" type="button" (click)="openView(lead)" title="View" aria-label="View">
                  <fa-icon [icon]="['fas', 'eye']"></fa-icon>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="footer">
      <div class="total-records">Total Records: {{ totalRecords }}</div>
      <div class="pagination-controls">
        <label for="lead-list-page-size">Records per page</label>
        <select id="lead-list-page-size" [(ngModel)]="pageSize" (change)="selectPageSize()">
            <option *ngFor="let option of pageSizeOptions" [value]="option">{{ option }}</option>
        </select>
        <span>{{ currentPage }} / {{ totalPages }}</span>
        <button (click)="previous()" [disabled]="!previousPage" class="change-page" title="Previous page">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="m15 18-6-6 6-6"/></svg>
        </button>
        <button (click)="next()" [disabled]="!nextPage" class="change-page" title="Next page">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="m9 18 6-6-6-6"/></svg>
        </button>
      </div>
    </div>
  </div>
</div>

<div class="lead-modal-backdrop" *ngIf="showDeleteLeadModal">
  <div class="lead-modal">
    <div class="lead-title">
      <h3>Delete Lead</h3>
      <p>Delete lead {{ leadPendingDelete?.lead_id || leadPendingDelete?.customer_name }}?</p>
    </div>
    <div class="inline-actions">
      <button class="lead-btn-muted" (click)="closeDeleteLeadModal()" [disabled]="deletingLead">Cancel</button>
      <button class="lead-btn-danger" (click)="confirmDeleteLead()" [disabled]="deletingLead">
        {{ deletingLead ? 'Deleting...' : 'Delete' }}
      </button>
    </div>
  </div>
</div>
